import React from 'react';
import { localize } from 'react-localize-redux';
import { renderpersonalReferences } from 'components/shared/PersonalReferenceFieldArray';

import { FieldArray } from 'redux-form';

class PersonalReferences extends React.Component {
  render() {
    return (
      <div className="row">
        <FieldArray name="personalReferences" component={renderpersonalReferences} />
      </div>
    );
  }
}

export default localize()(PersonalReferences);
